export const tokenAddress = "0xaD65106b738a9d1b0de6568251199e123084A131";
export const BoonAddress = "0x137f2b7f83c99E9d4C556d9803b6D2EfF64BbD24";

